import uuid from 'uuid'
import { GET_UNREAD_COUNTS, SET_UNREAD_COUNTS } from '@/store/mutation-types'
import { userPatientTrialService } from '@/services/user-patient-trial-service'
import { MyActiveOrganization } from '@/helpers/my-account-helper'

export const mutations = {
  ['REFRESH_USER_NOTIFICATIONS'](state, refreshUserNotifications) {
    state.refreshUserNotifications = refreshUserNotifications
  },
  [SET_UNREAD_COUNTS](state, unreadCounts) {
    state.unreadCounts = unreadCounts
  }
}

export const actions = {
  async ['REFRESH_USER_NOTIFICATIONS']({ commit }) {
    commit('REFRESH_USER_NOTIFICATIONS', uuid())
  },
  async [GET_UNREAD_COUNTS]({ commit }) {
    const { data } = await userPatientTrialService.getUnreadCounts(MyActiveOrganization.id)
    commit(SET_UNREAD_COUNTS, data)
  }
}

export const getters = {}
